import { TicketDetailsAttributes } from "./ticketDetailsView";

export interface EscalationRequestFormProps {
  isOpen: boolean;
  onDismiss: () => void;
  onEscalateTicket: (
    props: OnEscalateTicketProps
  ) => Promise<OnEscalateTicketResponse<TicketDetailsAttributes>>;
  onEscalationSuccess?: () => void;
  ticket: TicketDetailsAttributes;
  userName?: string;
  userEmail?: string;
}

export enum EscalationType {
  nudge = "esc_type_nudge",
  fire = "esc_type_fire",
}

export interface OnEscalateTicketProps {
  ticketId: number;
  escalationType: EscalationType;
  additionalInfo: string;
}

export interface OnEscalateTicketResponse<T> {
  data: T;
  message?: string;
  success: boolean;
  statusCode: number;
  status: number;
}

export interface EscalationRequestFormSubmitData {
  additionalInfo: string;
  escalationType: EscalationType;
  ticketId: number;
}
